import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { KeywordsInlineViewComponent } from './views/keywords-inline-view/keywords-inline-view.component';
import { ProductComponentBase } from '../../../ProductComponentBase';
import { ProductComponentStore, ProductKeywordsComponentStore } from 'products-data';

@Component({
  selector: 'ideal-keywords-inline',
  imports: [KeywordsInlineViewComponent],
  templateUrl: './keywords-inline.component.html',
  styleUrl: './keywords-inline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProductComponentStore, ProductKeywordsComponentStore],
})
export class KeywordsInlineComponent extends ProductComponentBase {
  private readonly _store = inject(ProductKeywordsComponentStore);
  public readonly match = input<string>('');
  public readonly matchType = input<'startsWith' | 'endsWith' | 'contains'>('startsWith');
  public readonly caseSensitiveMatch = input<boolean>(false);
  protected readonly keywords = computed(() => this._store.keywords());
  protected readonly keywordsLoading = computed(() => this._store.keywords.loading());

  constructor() {
    super();
    effect(() => {
      this._store.setSelectedProductId(this.productId());
    });
  }
}
